var map = {
	"./webBrand--billy-dash-dk.svg": "5e3b",
	"./webBrand--billy-dash-short-icon-dark.svg": "8027",
	"./webBrand--billy-dash-short-icon.svg": "aef2",
	"./webBrand--billy-dash-short-wh.svg": "3542",
	"./webBrand--billy-dash-short.svg": "8ebc",
	"./webBrand--billy-dash-wh.svg": "2693",
	"./webBrand--billy-dash.svg": "a58b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4eb4";